import { useEffect, useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function AdminTestimonialsPage() {
  const [tab, setTab] = useState('PENDING');
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('adminToken');

  const fetchTestimonials = () => {
    setLoading(true);
    fetch(`${API_BASE}/admin/testimonials?status=${tab}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => setTestimonials(json.success ? json.data : []))
      .finally(() => setLoading(false));
  };

  useEffect(fetchTestimonials, [tab]);

  const handleApprove = async (id) => {
    setTestimonials((prev) => prev.filter((t) => t.id !== id));
    await fetch(`${API_BASE}/admin/testimonials/${id}/approve`, { method: 'PATCH', headers: { Authorization: `Bearer ${token}` } });
  };

  const handleReject = async (id) => {
    setTestimonials((prev) => prev.filter((t) => t.id !== id));
    await fetch(`${API_BASE}/admin/testimonials/${id}/reject`, { method: 'PATCH', headers: { Authorization: `Bearer ${token}` } });
  };

  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen">
      <AdminSidebar />
      <main className="pt-16 md:pt-2 md:ml-64 min-h-screen p-8">
        <div className="mb-10 flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <h2 className="text-3xl font-bold text-[#00255a]">Testimonials Moderation</h2>
            <p className="text-[#64748b]">Manage and review student success stories before they go public.</p>
          </div>
        </div>

        <div className="flex gap-8 border-b border-[#e2e8f0] mb-8 overflow-x-auto">
          {['PENDING', 'APPROVED', 'REJECTED'].map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`pb-4 px-2 font-semibold whitespace-nowrap transition-all ${
                tab === t ? 'text-[#00255a] border-b-2 border-[#00255a]' : 'text-[#64748b] hover:text-[#00255a]'
              }`}
            >
              {t.charAt(0) + t.slice(1).toLowerCase()}
            </button>
          ))}
        </div>

        {loading ? (
          <p className="text-center text-[#64748b] py-20">Loading...</p>
        ) : testimonials.length === 0 ? (
          <p className="text-center text-[#64748b] py-20">No {tab.toLowerCase()} testimonials.</p>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
            {testimonials.map((t) => (
              <div key={t.id} className="bg-white rounded-xl border border-[#e2e8f0] p-6 flex flex-col h-full shadow-sm">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-[#8fb3ff] flex items-center justify-center text-white font-bold border-2 border-white shadow-sm">
                      {t.name?.charAt(0)}
                    </div>
                    <div>
                      <h4 className="text-lg text-[#00255a] font-bold">{t.name}</h4>
                      {t.country && (
                        <span className="text-xs font-semibold text-[#365da3] bg-[#d8e2ff]/30 px-2 py-0.5 rounded">{t.country}</span>
                      )}
                    </div>
                  </div>
                  <div className="flex text-[#ffb3b1]">
                    {Array.from({ length: t.rating || 5 }).map((_, i) => (
                      <span key={i} className="material-symbols-outlined text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>star</span>
                    ))}
                  </div>
                </div>

                <p className="text-[#64748b] line-clamp-3 italic mb-6">&quot;{t.quoteText}&quot;</p>

                {t.mediaUrl && (
                  <div className="mb-6 rounded-lg overflow-hidden h-40 bg-[#eceef0] relative group">
                    <img className="w-full h-full object-cover" src={t.mediaUrl} alt={t.name} />
                    {t.mediaType === 'VIDEO' && (
                      <div className="absolute inset-0 bg-[#00255a]/20 flex items-center justify-center">
                        <span className="material-symbols-outlined text-white text-5xl">play_circle</span>
                      </div>
                    )}
                  </div>
                )}

                {tab === 'PENDING' && (
                  <div className="mt-auto flex gap-3">
                    <button
                      onClick={() => handleApprove(t.id)}
                      className="flex-1 text-white font-semibold py-3 rounded-lg shadow hover:opacity-90 transition-opacity"
                      style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => handleReject(t.id)}
                      className="flex-1 border-2 border-[#e2e8f0] text-[#64748b] font-semibold py-3 rounded-lg hover:border-red-500 hover:text-red-500 transition-all"
                    >
                      Reject
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}